import management from "@/api/management";

export default {
  state: {
    managements: null,
    currentManagementId: null,
    currentYear:null,
    isPastManagement: false,
  },

  mutations: {
    ["MANAGEMENTS"](state, data) {
      state.managements = data;
    },
    ["CURRENT_MANAGEMENT"](state, data) {
      state.currentManagementId = data.management_id;
      state.currentYear = data.year;
    },
    ["IS_PAST_MANAGEMENT"](state, data) {
      state.isPastManagement = data;
    },
  },

  actions: {
    async showManagementID(context) {
      if (context.state.currentManagementId !== null) {
        return context.state.currentManagementId;
      }
      let management_id = "";
      try {
        let params = {
          account_id: await context.dispatch("showAccountID"),
        }
        let res = await management.showManagement(params);
        // console.log(res);
        if(res && res.data){
          if(1 < res.data.length){
            res.data.sort( function(a,b) {
                if (a.start_datetime < b.start_datetime){ return 1; }
                else if (a.start_datetime > b.start_datetime){ return -1; }
                else{ return 0; }
              }
            );
          }
          if(0 < res.data.length){
            context.commit("MANAGEMENTS", res.data);
            management_id = res.data[0]["management_id"];
            const year = parseInt(res.data[0].start_datetime.substr(0, 4));
            context.commit("CURRENT_MANAGEMENT", { management_id: management_id, year: year });
            context.commit("IS_PAST_MANAGEMENT", false);
          }
        }
      } catch (error) {
        console.log(error);
      }
      return management_id;
    },

    changeCurrentManagementId(context, id) {
      const allMng = context.state.managements;
      const selectMng = allMng.find(elm => elm.management_id === id);
      const selectYear = parseInt(selectMng.start_datetime.substr(0, 4));
      context.commit("CURRENT_MANAGEMENT", { management_id: id, year: selectYear });
      // 最新のManagementsは0番目の要素
      if (allMng[0].management_id === selectMng.management_id) {
        context.commit("IS_PAST_MANAGEMENT", false);
      }
      else {
        context.commit("IS_PAST_MANAGEMENT", true);
      }
    }
  },

  getters: {
    getManagements(state) {
      return state.managements;
    },
    getCurrentManagementId(state) {
      return state.currentManagementId;
    },
    getCurrentYear(state) {
      return state.currentYear;
    },
    isPastManagement(state) {
      return state.isPastManagement;
    },
  },
};
